<template>
    <v-dialog v-model="showDialog" scrollable :width="$vuetify.breakpoint.thresholds.md" persistent :fullscreen="$vuetify.breakpoint.xs">
        <template #activator="{ on, attrs }">
            <v-tooltip bottom>
                <template #activator="{ on: tooltipOn, attrs: tooltipAttrs }">
                    <v-btn
                        icon
                        v-on="{ ...on, ...tooltipOn }"
                        v-bind="{ ...attrs, tooltipAttrs }"
                        :color="type === 'ADD' ? 'success' : 'warning'"
                        :disabled="computedDisableType"
                    >
                        <v-icon>{{ type === 'ADD' ? 'mdi-plus' : 'mdi-pencil' }}</v-icon>
                    </v-btn>
                </template>
                <span>{{ computedTooptip }}</span>
            </v-tooltip>
        </template>
        <v-card>
            <v-toolbar dense flat color="secondary" dark>
                <v-toolbar-title>{{ computedTitle }}</v-toolbar-title>
                <v-spacer />
                <v-btn icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-tabs v-model="tabs" show-arrows mandatory slider-color="accent">
                <v-tab key="ACTIVITY">{{ $t('Aktivität') }}</v-tab>
                <v-tab key="ACTIVITY_TYPE">{{ $t('Aktivitätstyp') }}</v-tab>
                <v-tab key="MATERIALS">{{ $t('Material') }}</v-tab>
                <v-tab key="CONTENT">{{ $t('Content verlinken') }}</v-tab>
                <!-- <v-tab key="PREVIEW">{{ $t('Vorschau') }}</v-tab> -->
            </v-tabs>
            <v-card-text class="ma-0 pa-0">
                <v-tabs-items v-model="tabs" touchless>
                    <v-tab-item key="ACTIVITY" eager>
                        <v-form v-model="validate">
                            <v-container fluid>
                                <v-row align="center">
                                    <v-col :cols="11">
                                        <v-text-field
                                            :label="$t('Titel')"
                                            :hint="$t('Der Titel der Aktivität')"
                                            persistent-hint
                                            v-model="name"
                                            :rules="[rules('notEmpty')]"
                                        />
                                    </v-col>
                                    <v-col cols="auto">
                                        <TaxonomyTable v-model="taxonomy" selectable />
                                    </v-col>
                                    <v-col :cols="6">
                                        <DatePicker v-model="startDate" :min="minimumDate" :label="$t('Startdatum')" />
                                    </v-col>
                                    <v-col :cols="6">
                                        <DatePicker v-model="endDate" :min="startDate" :label1="$t('Enddatum')" />
                                    </v-col>
                                    <v-col :cols="12">
                                        <v-textarea
                                            :label="$t('Aufgabe')"
                                            :hint="$t('Aufgabenstellung für die Aktivität')"
                                            persistent-hint
                                            v-model="description"
                                            no-resize
                                            :rows="3"
                                        />
                                    </v-col>
                                    <v-col :cols="12">
                                        <v-textarea
                                            class="pb-2"
                                            :label="$t('Notizen')"
                                            :hint="$t('Notizen, nur für Lehrer sichtbar')"
                                            persistent-hint
                                            v-model="notes"
                                            no-resize
                                            :rows="3"
                                        />
                                    </v-col>
                                </v-row>
                            </v-container>
                            <v-expansion-panels accordion tile>
                                <v-expansion-panel>
                                    <v-expansion-panel-header>{{ $t('Erweiterte Einstellungen') }}</v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-container fluid>
                                            <v-row>
                                                <v-col :cols="6">
                                                    <v-text-field
                                                        :disabled="computedDisableSetScore"
                                                        :label="$t('Minimum Punkte')"
                                                        :hint="$t('Geben Sie eine minimale Punkzahl an, um den Kurs zu bestehen')"
                                                        persistent-hint
                                                        type="number"
                                                        min="0"
                                                        :rules="[rules('notNegative')]"
                                                        v-model="minScore"
                                                    />
                                                </v-col>
                                                <v-col :cols="6">
                                                    <v-text-field
                                                        :disabled="computedDisableSetScore"
                                                        :label="$t('Maximal erreichbare Punkte')"
                                                        :hint="$t('Geben Sie die maximal erreichbare Punktzahl an')"
                                                        persistent-hint
                                                        type="number"
                                                        min="0"
                                                        :rules="[rules('notNegative')]"
                                                        v-model="score"
                                                    />
                                                </v-col>
                                                <v-col :cols="6">
                                                    <v-switch
                                                        :label="$t('Startdatum erzwingen')"
                                                        :hint="$t('Wenn das Startdatum erzwungen wird, wird das Thema erst zum Startdatum verbergen')"
                                                        persistent-hint
                                                        v-model="forceStartDate"
                                                    />
                                                </v-col>
                                                <v-col :cols="6">
                                                    <v-switch
                                                        :label="$t('Enddatum erzwingen')"
                                                        :hint="$t('Wenn das Enddatum erzwungen wird, wird das Thema zum nächsten Tag geschlossen')"
                                                        persistent-hint
                                                        v-model="forceEndDate"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                                <v-expansion-panel>
                                    <v-expansion-panel-header>{{ $t('Erweitertes Zeitmanagement') }}</v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-container fluid>
                                            <v-row>
                                                <v-col :cols="6">
                                                    <v-text-field
                                                        :label="$t('Approximierte Arbeitszeit')"
                                                        :hint="$t('Geben Sie eine Zeit in Minuten an, in der der Kurs abzuarbeiten ist')"
                                                        persistent-hint
                                                        type="number"
                                                        min="0"
                                                        :rules="[rules('notNegative')]"
                                                        v-model="estimatedWorkTimeInMinutes"
                                                    />
                                                </v-col>
                                                <v-col :cols="6">
                                                    <v-text-field
                                                        :label="$t('Dauer in Tagen')"
                                                        :hint="$t('Geben Sie die Dauer in Tagen an')"
                                                        persistent-hint
                                                        type="number"
                                                        min="0"
                                                        :rules="[rules('notNegative')]"
                                                        v-model="durationInDays"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                                <v-expansion-panel>
                                    <v-expansion-panel-header>{{ $t('Sichtbarkeitsoptionen') }}</v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-container fluid>
                                            <v-row>
                                                <v-col :cols="6">
                                                    <v-switch
                                                        :label="$t('Vor Aktivitätsbeginn verbergen')"
                                                        :hint="
                                                            $t(
                                                                'Mit dieser Einstellung können Sie Aktivitäten, welche noch nicht begonnen haben, vor dem Benutzer verbergen'
                                                            )
                                                        "
                                                        persistent-hint
                                                        v-model="hideBeforeStart"
                                                    />
                                                </v-col>
                                                <v-col :cols="6">
                                                    <v-switch
                                                        :label="$t('Dauer in Tagen verbergen')"
                                                        :hint="$t('Mit dieser Einstellung können Sie Dauer in Tagen vor dem Benutzer verbergen')"
                                                        persistent-hint
                                                        v-model="hideDurationInDays"
                                                    />
                                                </v-col>
                                                <v-col :cols="12">
                                                    <v-switch
                                                        :label="$t('Approximierte Arbeitszeit verbergen')"
                                                        :hint="$t('Mit dieser Einstellung können Sie die geschätzte Arbeitszeit vor dem Benutzer verbergen')"
                                                        persistent-hint
                                                        v-model="hideEstimatedWorkTimeInMinutes"
                                                    />
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                                <v-expansion-panel>
                                    <v-expansion-panel-header>{{ $t('Benutzerdefinierte Typenbezeichnung') }}</v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-container fluid>
                                            <v-row>
                                                <v-col :cols="12">
                                                    <v-text-field
                                                        v-model="typeName"
                                                        :label="$t('Aktivitätsbezeichnung')"
                                                        :hint="computedActivityTypeNameHint"
                                                        persistent-hint
                                                        clearable
                                                    />
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-form>
                    </v-tab-item>
                    <v-tab-item key="ACTIVITY_TYPE" eager>
                        <v-container fluid>
                            <ActivityTypeSelector
                                v-model="activitySpecification"
                                :selectedActivity="getSelectedActivity.activityType"
                                :isUpdate="computedIsUpdate"
                                @validate="handleValidateActivityType"
                            />
                        </v-container>
                    </v-tab-item>
                    <v-tab-item key="MATERIALS" eager>
                        <v-container fluid>
                            <v-row>
                                <v-col :cols="12">
                                    <div style="overflow-x: hidden">
                                        <TextEditor v-model="material" />
                                    </div>
                                </v-col>
                                <v-col :cols="12">
                                    <Material v-model="materialMedia" />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item key="CONTENT" eager>
                        <KnowledgeContentManager selectable v-model="knowledgeContents" />
                    </v-tab-item>
                    <!-- <v-tab-item keys="PREVIEW">
                        <AddCourseUserPreview
                            v-model="showModal"
                            :isActivity="true"
                            :serializedData="serializedData"
                            :timeScaleInMinutes="getSelectedAdminCourse.timeScaleInMinutes"
                        />
                    </v-tab-item> -->
                </v-tabs-items>
            </v-card-text>
            <v-card-actions>
                <v-btn block :color="computedSubmitButtonColor" @click="save" :disabled="!computedIsActivityValid">
                    {{ computedSubmitButtonText }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import DatePicker from '../../Generic/PickerDate/PickerDate';
import ActivityTypeSelector from './ActivityTypes/ActivitySelector';
import KnowledgeContentManager from '../../KnowledgeContent/KnowledgeContentManager';
import TextEditor from '../../Generic/TextEditor';
import TaxonomyTable from './TaxonomyTable';
import CourseMixin from './Mixins/CourseMixin';
import KnowledgeContentMixin from '../../KnowledgeContent/Mixins/KnowledgeContentMixin';
import moment from 'moment';
// import AddCourseUserPreview from './AddCourseUserPreview';
import Material from './Material';

export default {
    name: 'add-update-activity',
    components: {
        DatePicker,
        ActivityTypeSelector,
        TaxonomyTable,
        KnowledgeContentManager,
        TextEditor,
        // AddCourseUserPreview,
        Material
    },
    mixins: [CourseMixin, KnowledgeContentMixin],
    data: () => ({
        showDialog: false,
        showModal: false,
        tabs: 0,
        validate: false,
        validateActivityType: false,
        activitySpecification: {
            type: 'UPLOAD'
        },
        taxonomy: {},
        id: '',
        name: '',
        description: '',
        notes: '',
        estimatedWorkTimeInMinutes: 0,
        folderId: '',
        durationInDays: '',
        forceStartDate: false,
        forceEndDate: false,
        hideEstimatedWorkTimeInMinutes: false,
        hideDurationInDays: false,
        hideBeforeStart: false,
        knowledgeContents: [],
        material: '',
        score: 0,
        minScore: 0,
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        typeName: null,
        initialLoad: false,
        serializedData: {},
        materialMedia: []
    }),
    watch: {
        showDialog(value) {
            if (value && !this.initialLoad) {
                this.initialLoad = true;
            }
            if (value) {
                if (this.type === 'UPDATE') {
                    if (this.getSelectedActivity.activityType === 'QUIZ') {
                        this.GET_QUIZ_EXCLUDED_KNOWLEDGE_UNITS(this.getSelectedActivity).then((response) => {
                            if (this.activitySpecification && this.activitySpecification.quiz && this.activitySpecification.quiz.excludeKnowledgeUnits) {
                                this.activitySpecification.quiz.excludeKnowledgeUnits = response;
                            }
                        });
                    }
                    Object.entries(this.getSelectedActivity).forEach(([key, value]) => (this.$data[key] = value));
                    this.GET_ACTIVITY_MATERIALS(this.getSelectedActivity).then(() => (this.materialMedia = this.getMaterial(this.getSelectedActivity)));
                } else if (this.type === 'ADD') {
                    this.startDate = this.getSelectedLearningGoal.startDate;
                    this.endDate = this.getSelectedLearningGoal.endDate;
                }
            }
        },
        startDate(value) {
            if (moment(value).isAfter(moment(this.endDate))) {
                this.endDate = moment(value).format('YYYY-MM-DD');
            }
        },
        minScore(value) {
            const toNumber = Number(value);
            if (toNumber >= this.score) {
                this.score = toNumber;
            }
        },
        tabs(value) {
            if (value === 4) {
                this.openUserPreview();
            }
        }
    },
    props: {
        type: {
            type: String,
            default: 'ADD',
            validator: (value) => ['ADD', 'UPDATE'].includes(value)
        }
    },
    computed: {
        computedDisableType() {
            if (this.type === 'ADD') {
                return false;
            }
            if (this.type === 'UPDATE') {
                return !Object.keys(this.getSelectedActivity).length > 0;
            }
            return false;
        },
        computedTooptip() {
            switch (this.type) {
                case 'ADD':
                    return this.$t('Aktivität erstellen');
                case 'UPDATE':
                    return this.$t('Aktivität bearbeiten');
            }
            return '';
        },
        computedDisableSetScore() {
            if (!this.getSelectedAdminCourse.useEvaluation) {
                return true;
            }
            return false;
        },
        computedActivityTypeNameHint() {
            return this.$t('Sie können statt "Aktivität" eine eigene Bezeichnung festlegen');
        },
        computedIsActivityValid() {
            return this.validate && this.validateActivityType;
        },
        computedIsUpdate() {
            return this.type === 'UPDATE';
        },
        computedTitle() {
            switch (this.type) {
                case 'ADD':
                    if (this.getSelectedLearningGoal.activityTypeName !== null && this.getSelectedLearningGoal.activityTypeName !== '') {
                        return `${this.getSelectedLearningGoal.activityTypeName} ${this.$t('erstellen')}`;
                    } else if (this.getSelectedTopic.activityTypeName !== null && this.getSelectedTopic.activityTypeName !== '') {
                        return `${this.getSelectedTopic.activityTypeName} ${this.$t('erstellen')}`;
                    } else if (this.getSelectedAdminCourse.activityTypeName !== null && this.getSelectedAdminCourse.activityTypeName !== '') {
                        return `${this.getSelectedAdminCourse.activityTypeName} ${this.$t('erstellen')}`;
                    }
                    return this.$t('Aktivität erstellen');

                case 'UPDATE':
                    if (this.typeName !== null && this.typeName !== '') {
                        return `${this.typeName} ${this.$t('bearbeiten')}`;
                    } else if (this.getSelectedLearningGoal.activityTypeName !== null && this.getSelectedLearningGoal.activityTypeName !== '') {
                        return `${this.getSelectedLearningGoal.activityTypeName} ${this.$t('bearbeiten')}`;
                    } else if (this.getSelectedTopic.activityTypeName !== null && this.getSelectedTopic.activityTypeName !== '') {
                        return `${this.getSelectedTopic.activityTypeName} ${this.$t('bearbeiten')}`;
                    } else if (this.getSelectedAdminCourse.activityTypeName !== null && this.getSelectedAdminCourse.activityTypeName !== '') {
                        return `${this.getSelectedAdminCourse.activityTypeName} ${this.$t('bearbeiten')}`;
                    }
                    return this.$t('Aktivität bearbeiten');
            }
            return '';
        },
        computedSubmitButtonText() {
            switch (this.type) {
                case 'ADD':
                    return this.$t('Hinzufügen');
                case 'UPDATE':
                    return this.$t('Aktualisieren');
            }
            return '';
        },
        computedSubmitButtonColor() {
            switch (this.type) {
                case 'ADD':
                    return 'success';
                case 'UPDATE':
                    return 'warning';
            }
            return '';
        },
        minimumDate() {
            return moment().format('YYYY-MM-DD');
        },
        handleDurationInDays() {
            if (this.durationInDays === '') {
                return moment(this.endDate).diff(this.startDate, 'days') + 1;
            } else if (this.durationInDays !== moment(this.endDate).diff(this.startDate, 'days') + 1) {
                return this.durationInDays;
            }
            return '';
        },
        setTypeName() {
            if (this.typeName === '') {
                return null;
            }
            return this.typeName;
        }
    },
    methods: {
        openUserPreview() {
            this.serializedData = this.serialize();
            this.showModal = true;
        },
        handleValidateActivityType(value) {
            this.validateActivityType = value;
        },
        handleSelected(value) {
            this.picture = value;
        },
        serialize() {
            return {
                id: this.id,
                name: this.name,
                description: this.description,
                notes: this.notes,
                activitySpecification: this.activitySpecification,
                activityType: this.activitySpecification.type,
                durationInDays: this.handleDurationInDays,
                estimatedWorkTimeInMinutes: this.estimatedWorkTimeInMinutes,
                folderId: this.folderId,
                forceStartDate: this.forceStartDate,
                forceEndDate: this.forceEndDate,
                knowledgeContents: this.knowledgeContents,
                taxonomy: this.taxonomy,
                material: this.material,
                score: this.score,
                minScore: this.minScore,
                startDate: this.startDate,
                endDate: this.endDate,
                typeName: this.setTypeName,
                hideBeforeStart: this.hideBeforeStart,
                hideEstimatedWorkTimeInMinutes: this.hideEstimatedWorkTimeInMinutes,
                hideDurationInDays: this.hideDurationInDays
            };
        },
        reset() {
            this.id = '';
            this.tabs = 0;
            this.name = '';
            this.taxonomy = {};
            this.materialMedia = [];
            this.material = '';
            this.description = '';
            this.notes = null;
            this.activitySpecification = { type: 'UPLOAD' };
            this.estimatedWorkTimeInMinutes = 0;
            this.folderId = '';
            this.forceStartDate = false;
            this.forceEndDate = true;
            this.knowledgeContents = [];
            this.score = 0;
            this.minScore = 0;
            this.startDate = moment().format('YYYY-MM-DD');
            this.endDate = moment().format('YYYY-MM-DD');
            this.hideEstimatedWorkTimeInMinutes = false;
            this.hideDurationInDays = false;
            this.durationInDays = '';
            this.typeName = null;
        },
        close() {
            this.showDialog = false;
            this.$nextTick(() => this.reset());
        },
        saveMaterials(activity) {
            const materialList = this.materialMedia.map((material) => {
                if (material.hasOwnProperty('id')) {
                    return this.UPDATE_MATERIAL(material);
                }
                return this.CREATE_MATERIAL(material);
            });
            Promise.all(materialList).then((result) => {
                this.UPDATE_ACTIVITY_MATERIALS({
                    ...activity,
                    materials: result
                });
            });
            return activity;
        },
        saveActivityToLearningGoal(activity) {
            this.UPDATE_LEARNING_GOAL_ACTIVITIES({
                learningGoal: this.getSelectedLearningGoal,
                activities: [...this.getLearningGoalActivities, activity]
            });
            return activity;
        },
        save() {
            switch (this.type) {
                case 'ADD': {
                    switch (this.activitySpecification.type) {
                        case 'UPLOAD':
                            return this.CREATE_FILE_ACTIVITY(this.serialize())
                                .then(this.saveActivityToLearningGoal)
                                .then(this.saveMaterials)
                                .then(() => this.close());
                        case 'SELF_CHECK':
                            return this.CREATE_CHECK_ACTIVITY(this.serialize())
                                .then(this.saveActivityToLearningGoal)
                                .then(this.saveMaterials)
                                .then(() => this.close());
                        case 'TEXT_FIELD':
                            return this.CREATE_TEXTFIELD_ACTIVITY(this.serialize())
                                .then(this.saveActivityToLearningGoal)
                                .then(this.saveMaterials)
                                .then(() => this.close());
                        case 'INFORM':
                            return this.CREATE_INFORM_ACTIVITY(this.serialize())
                                .then(this.saveActivityToLearningGoal)
                                .then(this.saveMaterials)
                                .then(() => this.close());
                        case 'QUIZ':
                            return this.CREATE_QUIZ_ACTIVITY(this.serialize())
                                .then(this.saveActivityToLearningGoal)
                                .then(this.saveMaterials)
                                .then(() => this.close());
                    }
                    return;
                }
                case 'UPDATE': {
                    switch (this.activitySpecification.type) {
                        case 'UPLOAD':
                            return this.UPDATE_FILE_ACTIVITY(this.serialize())
                                .then(this.saveActivityToLearningGoal)
                                .then(this.saveMaterials)
                                .then(() => this.close());
                        case 'SELF_CHECK':
                            return this.UPDATE_CHECK_ACTIVITY(this.serialize())
                                .then(this.saveActivityToLearningGoal)
                                .then(this.saveMaterials)
                                .then(() => this.close());
                        case 'TEXT_FIELD':
                            return this.UPDATE_TEXTFIELD_ACTIVITY(this.serialize())
                                .then(this.saveActivityToLearningGoal)
                                .then(this.saveMaterials)
                                .then(() => this.close());
                        case 'INFORM':
                            return this.UPDATE_INFORM_ACTIVITY(this.serialize())
                                .then(this.saveActivityToLearningGoal)
                                .then(this.saveMaterials)
                                .then(() => this.close());
                        case 'QUIZ':
                            return this.UPDATE_QUIZ_ACTIVITY(this.serialize())
                                .then(this.saveActivityToLearningGoal)
                                .then(this.saveMaterials)
                                .then(() => this.close());
                    }
                    return;
                }
            }
        },
        rules(type) {
            switch (type) {
                case 'notNegative':
                    return (v) => {
                        if (v !== undefined && v !== null) {
                            const toNumber = Number(v);
                            return toNumber >= 0 || this.$t('Bitte geben Sie eine Zahl größer oder gleich 0 an');
                        }
                    };
                case 'notEmpty':
                    return (v) => !!v || this.$t('Dieses Feld darf nicht leer sein');
            }
        }
    },
    beforeMount() {
        this.GET_KNOWLEDGE_CONTENTS();
    }
};
</script>
